import { omit } from 'lodash-es';

import {
  useAllObjectClassListQuery,
  useTaskUpdateMutation,
  useUpdateTaskUserMutation,
} from '@/hook';
import { Edit, VButton, VFlex } from '@/package';
import type { Project, Task } from '@/type';

import { TaskCreateForm } from '../Task';
import type { TaskCreateFormType } from '../Task/TaskCreateForm/type';

export const TaskOverview = ({
  projectData,
  taskDetail,
}: {
  projectData: Project;
  taskDetail: Task;
}) => {
  const { mutateAsync: updateTask } = useTaskUpdateMutation();
  const { mutateAsync: updateTaskUser } = useUpdateTaskUserMutation();
  const { data: allObjectClassList } = useAllObjectClassListQuery();

  return (
    <div className="size-full w-[972px] overflow-x-hidden overflow-y-hidden pt-4">
      <div className="size-full overflow-x-hidden overflow-y-auto pb-10">
        {taskDetail && allObjectClassList && projectData && (
          <TaskCreateForm
            key={taskDetail.updatedAt}
            renderFooter={methods => {
              const onClick = () => {
                const { distance, dueDate, startDate, worker } =
                  methods.getValues();
                const updateResList = [] as Promise<any>[];

                updateResList.push(
                  updateTask({
                    ...omit(taskDetail, ['extendClass', 'classConfidence']),
                    ...omit(methods.getValues(), ['classConfidence']),
                    classConfidence: {
                      confidence:
                        methods.getValues('classConfidence')?.map(item => ({
                          id: item.id,
                          confidence: Number(item.confidence),
                        })) ?? [],
                    },
                    extendClass: taskDetail.extendClass ?? [],
                    distance: Number(distance),
                    workFrameInterval: Number(taskDetail.workFrameInterval),
                    pTaskID: taskDetail.id,
                    projectID: taskDetail.projectID,
                    startDate: startDate ? `${startDate}` : '',
                    dueDate: dueDate ? `${dueDate}` : '',
                  }),
                );

                if (worker?.length) {
                  updateResList.push(
                    updateTaskUser({
                      taskID: taskDetail.id,
                      worker,
                    }),
                  );
                }

                return Promise.all(updateResList);
              };

              const isTouched = methods.formState.isDirty;
              const isValid = methods.formState.isValid;

              return (
                <VFlex className="w-full" justify="end">
                  <VButton
                    className="w-[478px]"
                    onClick={onClick}
                    type="button"
                    disabled={!isTouched || !isValid}
                  >
                    <Edit />
                    Edit
                  </VButton>
                </VFlex>
              );
            }}
            defaultValue={
              // NOTE: Overview 쪽은 TaskCreateFormType 을 강하게 맞출 필요가 없기 때문에 강제로 as 로 형변환을 진행
              {
                ...taskDetail,
                worker: taskDetail.userTask
                  ?.map(userTask => userTask.user)
                  .filter(user => !!user),
                classConfidence:
                  taskDetail.classConfidence?.confidence?.map(item => ({
                    id: item.id,
                    confidence: Number(item.confidence),
                    classType:
                      allObjectClassList.find(cls => cls.id === item.id)
                        ?.classType ?? 'Super',
                  })) ?? [],
              } as TaskCreateFormType
            }
            readOnlyField={{
              classConfidence: true,
              distance: true,
              taskFolder: true,
              workFrameInterval: true,
              worker: false,
            }}
            projectData={projectData}
          />
        )}
      </div>
    </div>
  );
};

TaskOverview.displayName = 'TaskOverview';
